export const formatTime = (date) => {
  console.log({ date }, " datedate");
  const newDate = new Date(date);

  const options = {
    hour12: true,
    hour: "2-digit",
    minute: "2-digit",
  };

  const formattedTime = newDate.toLocaleTimeString("en-US", options);

  return formattedTime;
};


export const formatDate = (dateString) => {
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};